import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";

export const PolygonsRenderer = ({ polygons, color }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // Clear previously rendered polygons
    const googlePolygons = [];

    // Add polygons to the map
    polygons.forEach(({ coordinates }) => {
      const polygon = new window.google.maps.Polygon({
        paths: coordinates,
        map,
        fillColor: color,
        fillOpacity: 0, // 0 fill
        strokeColor: color,
        strokeWeight: 3,
      });

      googlePolygons.push(polygon);
    });

    // Cleanup function to remove polygons when component unmounts or dependencies change
    return () => {
      googlePolygons.forEach((polygon) => {
        polygon.setMap(null);
        window.google.maps.event.clearInstanceListeners(polygon);
      });
    };
  }, [map, polygons, color]);

  return null;
};
